var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.494 9.39209C24.805 9.7173 24.0695 9.9329 23.314 10.0311C24.1209 9.50955 24.7133 8.71521 24.983 7.79309C24.2464 8.26268 23.431 8.59504 22.576 8.77409C21.885 7.99109 20.896 7.49609 19.805 7.49609C17.357 7.49609 15.556 9.93009 16.11 12.4591C12.955 12.2931 10.16 10.6841 8.288 8.23809C7.291 10.0531 7.775 12.4291 9.464 13.6351C8.85691 13.6138 8.26499 13.4398 7.743 13.1291C7.703 14.9991 8.959 16.7551 10.788 17.1441C10.2303 17.3033 9.64278 17.3273 9.074 17.2141C9.561 18.8211 10.958 19.9871 12.619 20.0181C11.021 21.3451 9.013 21.9401 7 21.6891C8.679 22.8351 10.672 23.5051 12.815 23.5051C19.861 23.5051 23.84 17.1661 23.601 11.4871C24.3513 10.9066 24.9923 10.1972 25.494 9.39209Z",
    fill: "#212121"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.a8c2924a5e9420bc2f34b7b88cc14552.svg";
export { ForwardRef as ReactComponent };